module.exports = __webpack_public_path__ + "img/d3.2cf71da2.png";